import { IsIn, IsNotEmpty, IsOptional, IsString, Length } from 'class-validator';

const LICENSE_LEVELS = ['Federal', 'State'] as const;
const DEA_SCHEDULES = ['OTC', 'RX', 'C1', 'C2', 'C2N', 'C3', 'C3N', 'C4', 'C5'] as const;

export class CreateItemDeaScheduleDto {
	@IsNotEmpty()
	@IsString()
	@IsIn(LICENSE_LEVELS)
	public licenseLevel!: 'Federal' | 'State';

	@IsOptional()
	@IsString()
	@Length(2, 2)
	public state?: string;

	@IsNotEmpty()
	@IsString()
	@IsIn(DEA_SCHEDULES)
	public schedule!: 'OTC' | 'RX' | 'C1' | 'C2' | 'C2N' | 'C3' | 'C3N' | 'C4' | 'C5';

	public constructor(data?: CreateItemDeaScheduleDto) {
		if (data != null) {
			this.licenseLevel = data.licenseLevel;
			this.state = data.state;
			this.schedule = data.schedule;
		}
	}
}

export class UpdateItemDeaScheduleDto {
	@IsOptional()
	@IsString()
	@IsIn(LICENSE_LEVELS)
	public licenseLevel?: 'Federal' | 'State';

	@IsOptional()
	@IsString()
	@Length(2, 2)
	public state?: string;

	@IsOptional()
	@IsString()
	@IsIn(DEA_SCHEDULES)
	public schedule?: 'OTC' | 'RX' | 'C1' | 'C2' | 'C2N' | 'C3' | 'C3N' | 'C4' | 'C5';
}

export class ItemDeaScheduleResponseDto {
	public _id!: number;
	public fk_item__id!: number;
	public licenseLevel!: string | null;
	public state!: string | null;
	public schedule!: string | null;
	public _created_date!: Date;
	public _modified_date!: Date;

	public constructor(data?: ItemDeaScheduleResponseDto) {
		if (data != null) {
			this._id = data._id;
			this.fk_item__id = data.fk_item__id;
			this.licenseLevel = data.licenseLevel;
			this.state = data.state;
			this.schedule = data.schedule;
			this._created_date = data._created_date;
			this._modified_date = data._modified_date;
		}
	}
}
